import instance from "@/services/axiosConfig";
import appInstance from "./applicationService/appinstance";

// MODULECREATIONS

const createbenchmarkTrigger = (payload) =>
  instance.post(`/create/benchmarkcalculation`, payload);

// const createtriggertable = (payload) =>
//   instance.post(`/create/triggertable`, payload);

// MODULECREATIONS

const getcustomModuleSpecific = () =>
  instance.get("/create/module-specific-validations");


const customModuleSpecific = (payload) =>
  instance.post("/create/module-specific-validations", payload);



const backupHandleProcess = (data) =>
  instance.post("/create/background-backup", data);
const getBackupData = () => instance.get("/create/getbackup-indexdb");

const getModulesforUser = (eventName) =>
  instance.get(`/create/viewModuleforuser/${eventName}`);

const updateUserpassword = (payload) =>
  appInstance.put("/updatepassword", payload);

const getmoduleDataedit = () => instance.get("/create/viewModulereport");

const deleteDatabyEvent = (payload) =>
  instance.post(`/create/deleteeventdata`, payload);

const getallPreviousPlaceholder = () =>
  instance.get(`/create/getbunkerplaceholders`);

const getownerDataedit = (id) =>
  instance.get(`/create/getowneruserreport/${id}`);

const addDataintoModule = (payload) =>
  instance.post("/create/insertData/daily", payload);
const updateDataModule = (payload) =>
  instance.put("/create/updateData/daily", payload);

const syncDailyModule = (payload) =>
  instance.post("/create/insertData/dailysync", payload);

const getAllWarningbyShip = (ship_id) =>
  instance.get(`/create/getwarnings/${ship_id}`);

const syncWarnings = (payload) =>
  instance.post("/create/savewarnings", payload);

const addDataintoModule1 = (payload) =>
  instance.post("/create/insertData/multi", payload);

const getTableDataService = (data) =>
  instance.get(`/create/getTabledata/${data}`);

const getDerivedModules = () => instance.get(`/create/getallderivedfield`);

const getDerivedModulesBytablename = (tname) =>
  instance.get(`/create/get-tabledetails/${tname}`);

const getDerivedModulesLevel3 = () =>
  instance.get("/create/getallderivedfieldlevel3");

const getLatestTableData = (data) =>
  instance.get(`/create/getlatestTableRecords/${data}`);

const getTableDataFromTablename = (tablename, type = "", page = { page: 1 }) => {
  const pageNumber = page?.page || 1;

  return instance.get(
    `/create/getTableRecords/${tablename}/${type}?page=${pageNumber}`
  );
};

const getTableDataFromTablenameByshipid = (payload) =>
  instance.post(`/create/getTableRecords`, payload);

const updateDataTable = (data, payload) =>
  instance.post(`/create/updateTableRecords/${data}`, payload);

const deleteEventRecords = (payload) =>
  instance.put(`/create/deleteEventRecords`, payload);

const getExcelData = (data) =>
  instance.get(`/create/getExcel/${data}`, { responseType: "blob" });

// const getAllDraft = () => instance.get(`/create/getdraft`);

const getAllDraft = (type) =>
  instance.get(`/create/getdraft${!type ? "" : `?draft_type=${type}`}`);

const createDraft = (data) => instance.post(`/create/draft`, data);

const updateDraft = (data, id) => instance.put(`/create/draft/${id}`, data);

const getDraft = (id) => instance.get(`/create/getdraft/${id}`);

const deleteDraft = (id) => instance.patch(`/create/getdraft/${id}`);

const deleteDraftBydate = (date) =>
  instance.patch(`/create/getdraftbydate/${date}`);

const createTriggerView = (payload) => {
  instance.post("/create/triggerview", payload);
};
const createMaterializedTriggerView = (payload) => {
  instance.post("/create/triggermaterializedview", payload);
};
const createMonthlyTriggerView = (payload) => {
  instance.post("/create/triggermonthlyview", payload);
};
const createFunction = (payload) => {
  instance.post("/create/function", payload);
};


const fetchModuleOrder = () =>
  instance.get(`/create/module-order`);

const updateModuleOrder = (data) =>
  instance.put(`/create/module-order`, data);



const userService = {
  fetchModuleOrder,
  updateModuleOrder,
  createMonthlyTriggerView,
  createMaterializedTriggerView,
  createbenchmarkTrigger,
  updateDataTable,
  getExcelData,
  getTableDataFromTablename,
  getModulesforUser,
  addDataintoModule,
  getTableDataService,
  getDerivedModules,
  getLatestTableData,
  getDerivedModulesLevel3,
  getmoduleDataedit,
  updateUserpassword,
  addDataintoModule1,
  getTableDataFromTablenameByshipid,
  getownerDataedit,
  getAllDraft,
  deleteDraft,
  deleteDraftBydate,
  getDraft,
  updateDraft,
  createDraft,
  getDerivedModulesBytablename,
  deleteDatabyEvent,
  syncDailyModule,
  backupHandleProcess,
  getBackupData,
  deleteEventRecords,
  getallPreviousPlaceholder,
  createTriggerView,
  getAllWarningbyShip,
  syncWarnings, updateDataModule, createFunction, getcustomModuleSpecific, customModuleSpecific
};
export default userService;
